import { RefundFormValues, RefundFormViolation } from '../types/refundTypes';

export const createRefundFormValues = (): RefundFormValues => ({
  amount: '',
  comment: '',
});

export const validateRefundFormValues = (
  values: RefundFormValues
): RefundFormViolation[] => {
  const violations: RefundFormViolation[] = [];

  if (!values.amount || Number(values.amount) <= 0) {
    violations.push({
      name: 'MissingAmount',
    });
  }

  if (!values.comment.trim()) {
    violations.push({
      name: 'MissingComment',
    });
  }

  return violations;
};

export const createRefundFormViolationLense = (
  violation: RefundFormViolation
) => ({
  isCommentViolation() {
    switch (violation.name) {
      case 'MissingComment':
        return true;
      default:
        return false;
    }
  },
  isAmountViolation() {
    switch (violation.name) {
      case 'MissingAmount':
      case 'AmountExceedsBalance':
        return true;
      default:
        return false;
    }
  },
});
